import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { ProgressComponent } from '@coreui/angular-pro';

@Component({
  selector: 'app-stepper',
  imports: [ProgressComponent, CommonModule],
  templateUrl: './stepper.component.html',
  styleUrl: './stepper.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class StepperComponent {
  @Input() step: number = 0;
  @Input() max: number = 5;

  get progressValue(): number {
    return (this.step / this.max) * 100;
  }
}
